import { render, staticRenderFns } from "./studentAttendance.vue?vue&type=template&id=0bef10e4&scoped=true&"
import script from "./studentAttendance.vue?vue&type=script&lang=js&"
export * from "./studentAttendance.vue?vue&type=script&lang=js&"
import style0 from "./studentAttendance.vue?vue&type=style&index=0&id=0bef10e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef10e4",
  null
  
)

export default component.exports